module.exports = __webpack_public_path__ + "media/images/footer_twitter-96a1542d436cf8a03efe353cb1bf28b4.png";